<div class="impressum__container">
<div>
  <h1>Impressum</h1>
</div>
<div>
  <p>SPIRIT-TESTING Software & Services GmbH</p>
  <p>Machtlfinger Str. 11</p>
  <p>81379 München</p>
  <p>Fon: +49(0)89 41 41 42 290</p>
  <p>Fax: +49(0)89 41 41 42 299</p>
</div>
<br />
<div>
  <p>Geschäftsführer: Jürgen Volles</p>
  <p>Prokurist: Dr. Bernhard Kopp</p>
  <p>Handelsregister: München HRB 144367</p>
  <p>Steuer-Nr.: 143/182/11214</p>
  <p>UST-Id.: DE 224 654 463</p>
  <br />
  <p>Part of TestSolutions Group</p>
</div>

<div>
  <h2>Disclaimer/ Haftungsausschluss</h2>
  <h3>1. Inhalt des Onlineangebotes</h3>
  <p>
    Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit,
    Vollständigkeit oder Qualität der bereitgestellten Informationen.
    Haftungsansprüche gegen den Autor, welche sich auf Schäden materieller oder
    ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der
    dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und
    unvollständiger Informationen verursacht wurden, sind grundsätzlich
    ausgeschlossen, sofern seitens des Autors kein nachweislich vorsätzliches
    oder grob fahrlässiges Verschulden vorliegt. Alle Angebote sind freibleibend
    und unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der
    Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu
    ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig
    einzustellen.
  </p>
  <h3>2. Verweise und Links</h3>
  <p>
    Bei direkten oder indirekten Verweisen auf fremde Webseiten (“Hyperlinks”),
    die außerhalb des Verantwortungsbereiches des Autors liegen, würde eine
    Haftungsverpflichtung ausschließlich in dem Fall in Kraft treten, in dem der
    Autor von den Inhalten Kenntnis hat und es ihm technisch möglich und
    zumutbar wäre, die Nutzung im Falle rechtswidriger Inhalte zu verhindern.
    Der Autor erklärt hiermit ausdrücklich, dass zum Zeitpunkt der Linksetzung
    keine illegalen Inhalte auf den zu verlinkenden Seiten erkennbar waren. Auf
    die aktuelle und zukünftige Gestaltung, die Inhalte oder die Urheberschaft
    der verlinkten/verknüpften Seiten hat der Autor keinerlei Einfluss. Deshalb
    distanziert er sich hiermit ausdrücklich von allen Inhalten aller verlinkten
    /verknüpften Seiten, die nach der Linksetzung verändert wurden. Diese
    Feststellung gilt für alle innerhalb des eigenen Internetangebotes gesetzten
    Links und Verweise sowie für Fremdeinträge in vom Autor eingerichteten
    Gästebüchern, Diskussionsforen, Linkverzeichnissen, Mailinglisten und in
    allen anderen Formen von Datenbanken, auf deren Inhalt externe
    Schreibzugriffe möglich sind. Für illegale, fehlerhafte oder unvollständige
    Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung
    solcherart dargebotener Informationen entstehen, haftet allein der Anbieter
    der Seite, auf welche verwiesen wurde, nicht derjenige, der über Links auf
    die jeweilige Veröffentlichung lediglich verweist.
  </p>
  <h3>3. Urheber- und Kennzeichenrecht</h3>
  <p>
    Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der
    verwendeten Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zu
    beachten, von ihm selbst erstellte Bilder, Grafiken, Tondokumente,
    Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken,
    Tondokumente, Videosequenzen und Texte zurückzugreifen. Alle innerhalb des
    Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und
    Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils
    gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen
    eingetragenen Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der
    Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter geschützt
    sind! Das Copyright für veröffentlichte, vom Autor selbst erstellte Objekte
    bleibt allein beim Autor der Seiten. Eine Vervielfältigung oder Verwendung
    solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen
    elektronischen oder gedruckten Publikationen ist ohne ausdrückliche
    Zustimmung des Autors nicht gestattet.
  </p>
  <h3>4. Rechtswirksamkeit dieses Haftungsausschlusses</h3>
  <p>
    Dieser Haftungsausschluss ist als Teil des Internetangebotes zu betrachten,
    von dem aus auf diese Seite verwiesen wurde. Sofern Teile oder einzelne
    Formulierungen dieses Textes der geltenden Rechtslage nicht, nicht mehr oder
    nicht vollständig entsprechen sollten, bleiben die übrigen Teile des
    Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.
  </p>
</div>
</div>
